import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// API client específico do Painel Central (usa painel_token)
const painelApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

painelApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('painel_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

painelApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('painel_token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default painelApi;
